<template>
  <swiper
    ref="cellListSwiper"
    :options="swiperOptions"
    :cell-type="thumbnailInfo.type"
    :class="[`swiper`, thumbnailInfo.componentName]"
  >
    <swiper-slide v-for="(cell, index) in cellList" :key="index">
      <component
        :is="component"
        :cell-info="cell"
        :thumbnail-info="thumbnailInfo"
        :loaded-fn="loaded"
        :cell-index="index"
        @on-click="onClick(cell, index)"
        @on-click-detail="onClickDetail(cell, index)"
      />
    </swiper-slide>
    <div
      slot="button-prev"
      class="swiper-button-prev"
      :class="`${thumbnailInfo.type === 'band_highlight' ? 'highlight' : ''}`"
    />
    <div
      slot="button-next"
      class="swiper-button-next"
      :class="`${thumbnailInfo.type === 'band_highlight' ? 'highlight' : ''}`"
    />
    <slot name="banner-wrapper" />
  </swiper>
</template>
<script>
  import _ from 'lodash'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import LandscapeCell from '@/components/model/cell/LandscapeCell'
  import CircleCell from '@/components/model/cell/CircleCell'
  import PortraitCell from '@/components/model/cell/PortraitCell'
  import CellMixIn from '@/mixins/cell.mixin'
  import ImageBoxCell from '@/components/model/cell/ImageBoxCell.vue'
  import AnimationBoxCell from '@/components/model/cell/AnimationBoxCell.vue'
  import shave from 'shave'
  import EditorPickPackageCell from '@/components/model/cell/EditorPickPackageCell'
  import PortraitRankingCell from '@/components/model/cell/PortraitRankingCell'
  import LandscapeRankingCell from '@/components/model/cell/LandscapeRankingCell.vue'
  import { LOG_SEND_LIST } from '@/common/resources/log.v2.const'
  import { sendEventLogSearchCell } from '@/common/utils/log.v2.send'
  import {
    COMMON_SWIPER_OPTIONS,
    SLIDES_PER_GROUP,
  } from '@/common/resources/swiper.const'

  export default {
    name: 'CellList',
    components: {
      swiper,
      swiperSlide,
      CircleCell,
      LandscapeCell,
      PortraitCell,
      EditorPickPackageCell,
      PortraitRankingCell,
      ImageBoxCell,
      LandscapeRankingCell,
      AnimationBoxCell,
    },
    mixins: [CellMixIn],
    props: {
      cellList: {
        type: Array,
      },
      cellType: {
        type: String,
      },
      thumbnailInfo: {
        type: Object,
      },
      title: {
        type: String,
      },
    },
    data() {
      return {
        component: null,
        timer: null,
        swiperOptions: null,
        isHover: false,
      }
    },
    computed: {
      swiper() {
        return this.$refs.cellListSwiper.swiper
      },
    },
    created() {
      this.swiperOptions = this.swiperOptionsByCellType()
      this.component = this.thumbnailInfo.componentName
    },
    mounted() {
      if (this.swiper.activeIndex === 0) {
      }
    },
    beforeDestroy() {
      const destroyFn = _.get(
        this.$refs,
        ['cellListSwiper.$destroy'],
        function () {},
      )
      destroyFn()
    },
    methods: {
      // send-search-event-log
      sendLog(cellInfo = {}, index = -1) {
        if (LOG_SEND_LIST.includes(this.$route.name)) {
          sendEventLogSearchCell({
            cellInfo,
            index,
            routeName: this.$route.name,
          })
        }
      },
      // on-detail
      onClickDetail(cellInfo = {}, index = -1) {
        if (index > -1) {
          this.sendLog(cellInfo, index)
          this.goDetailView(cellInfo)
        }
      },
      // on-navigation
      onClick(cellInfo = {}, index = -1) {
        if (index > -1) {
          this.sendLog(cellInfo, index)
          this.goNavigationView(cellInfo)
        }
      },
      loaded(elList) {
        elList.forEach((el) => {
          shave(el, 28)
        })
      },
      swiperOptionsByCellType() {
        const cellType = _.get(this.thumbnailInfo, 'type', '')
        const swiperOptions = {
          height: this.thumbnailInfo.height,
          spaceBetween: COMMON_SWIPER_OPTIONS.SPACE_BETWEEN,
          slidesPerView: COMMON_SWIPER_OPTIONS.SLIDES_PER_VIEW,
          slidesPerGroup: SLIDES_PER_GROUP.VERTICAL_L,
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev',
          observer: true,
          onSlideChangeEnd: (swiper) => {
            const { isEnd, activeIndex } = swiper
            this.isHover = !isEnd && activeIndex !== 0
          },
        }
        switch (cellType) {
          case 'band_61':
            swiperOptions.paginationClickable = false
            swiperOptions.touchRatio = 0
            break
          case 'band_2':
            swiperOptions.slidesPerGroup = SLIDES_PER_GROUP.HORIZONTAL_M
            break
          case 'band_myview':
            swiperOptions.slidesPerGroup = SLIDES_PER_GROUP.HORIZONTAL_M
            break
          case 'band_71':
          case 'band_82':
            // editor pick, comming soon
            swiperOptions.slidesPerGroup = SLIDES_PER_GROUP.HORIZONTAL_L
            break
          case 'band_highlight':
            swiperOptions.slidesPerGroup = SLIDES_PER_GROUP.HIGHLIGHT
            break
          case 'band_21':
          case 'band_image_box':
            swiperOptions.spaceBetween = 10
            break
          case 'band_2_rank':
            swiperOptions.spaceBetween = 9.5
            swiperOptions.slidesPerGroup = SLIDES_PER_GROUP.HORIZONTAL_L
            break
        }
        return swiperOptions
      },
    },
  }
</script>
<style lang="scss" scoped>
  $swiper-button-margin: 100px;

  // cell types gradient heights
  $cell-heights: (
    portrait: 360px,
    landscape: 170px,
    editor-pick-package: 230px,
    animation-box: 99px,
    circle: 160px,
    image-box: 152px,
    portrait-ranking: 395px,
    landscape-ranking: 229px,
  );

  .multi {
    .swiper-slide {
      width: auto;
    }

    @each $cell-type, $height in $cell-heights {
      .#{$cell-type}-cell {
        .swiper-button-prev,
        .swiper-button-next {
          &:before {
            height: $height;
          }
        }
      }
    }

    .swiper-button-prev,
    .swiper-button-next {
      left: 70px;
      opacity: 0;
      &:before {
        content: '';
        opacity: 0;
        position: absolute;
        left: -$swiper-button-margin;
        top: 50%;
        transform: translateY(-50%);
        width: 60px;
        height: 360px;
        transition: opacity 0.1s ease-in;
        background: linear-gradient(
          270deg,
          rgba(27, 27, 27, 0) 0%,
          rgba(27, 27, 27, 0.8) 100%
        );
        z-index: 10;
      }
    }
    .swiper-button-next {
      left: auto;
      right: 70px;
      &:before {
        left: auto;
        right: -$swiper-button-margin;
        background: linear-gradient(
          270deg,
          rgba(27, 27, 27, 0.8) 0%,
          rgba(27, 27, 27, 0) 100%
        );
      }
    }
    // portrait ranking cell top 변경
    .portrait-ranking-cell {
      .swiper-button-prev,
      .swiper-button-next {
        &:before {
          top: calc(50% + 18px);
        }
      }
    }

    .swiper-button-prev.highlight {
      left: -30px;
    }
    .swiper-button-next.highlight {
      right: -30px;
    }
    &:hover {
      .swiper-button-prev,
      .swiper-button-next {
        left: 100px;
        opacity: 1;
        &:before {
          opacity: 1;
        }
      }
      .swiper-button-next {
        left: auto;
        right: 100px;
      }
      .swiper-button-prev.highlight {
        left: 0;
      }
      .swiper-button-next.highlight {
        right: 0;
      }
      .swiper-button-prev.swiper-button-disabled {
        opacity: 0;
        cursor: auto;
      }
      .swiper-button-next.swiper-button-disabled {
        opacity: 0;
        cursor: auto;
      }
    }
    .btn-more.all {
      right: 100px;
    }
  }

  .swiper-container {
    position: relative;
    padding: 0 100px;
    min-width: 1440px;
    min-height: 440px;
    &:after {
      left: auto;
      right: 0;
      background: linear-gradient(
        90deg,
        rgba(244, 245, 246, 0) 0%,
        #1b1b1b 100%
      );
    }
  }
  .ppv-wrap .swiper.portrait-cell {
    min-height: 498px;
  }
  .swiper.landscape-cell {
    min-height: 272px;
    &:before,
    &:after {
      height: 250px;
    }
  }
  .swiper.editor-pick-package-cell {
    min-height: 310px;
    &:before,
    &:after {
      height: 230px;
    }
  }
  .swiper.circle-cell {
    overflow: hidden;
    min-height: 248px;
    &:before,
    &:after {
      height: 160px;
    }
  }

  .swiper.image-box-cell {
    min-height: 168px;
    &:before,
    &:after {
      height: 152px;
    }
  }

  .swiper.landscape-ranking-cell {
    min-height: 393px;
    &:before,
    &:after {
      height: 393px;
    }
  }

  .swiper.animation-box-cell {
    min-height: 174px;
    &:before,
    &:after {
      height: 174px;
    }
  }

  .swiper-pagination,
  .swiper-button-prev,
  .swiper-button-next {
    will-change: transform;
    transform: translateZ(0);
  }
  .ppv-layer-outer {
    position: absolute;
    top: 0;
    display: block;
    content: '';
    width: 100%;
    z-index: 2;
    height: 100%;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.7);
  }
  .ppv-layer-lnner {
    width: 1240px;
    margin: 0 auto;
  }
  .ppv-intro,
  .ppv-link,
  .ppv-notification {
    display: block;
    text-align: center;
  }
  .ppv-intro {
    margin-top: 149px;
    margin-bottom: 8px;
    font-size: 36px;
    line-height: 54px;
  }
  .ppv-link {
    width: 285px;
    margin: 0 auto;
    padding: 20px 0;
    font-size: 18px;
    line-height: 27px;
    color: #fff;
    background-color: #1351f9;
    border-radius: 34px;
  }
  .ppv-notification {
    position: relative;
    padding-left: 6px;
    margin-top: 64px;
    color: #a5a5a5;
  }
  .ppv-notification:before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    width: 2px;
    height: 2px;
    margin-right: 4px;
    background-color: #a5a5a5;
    border-radius: 1px;
  }
  .ppv-notification > span {
    font-size: 16px;
    line-height: 24px;
    display: inline-block;
    vertical-align: middle;
  }
</style>
